import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@latitude/link';
import {
  PADDING,
  REBRAND_COLOR,
  REBRAND_SHADOW,
  MARGIN
} from '@latitude/core/utils/constants';
import Typography from '@latitude/typography';

const ArticleCard = styled(Link)`
  display: block;
  text-decoration: none;
  box-shadow: ${REBRAND_SHADOW.CARD};
  border-radius: 16px;
  text-shadow: none;
  border-bottom: none;
    &:hover, &:focus {
    text-shadow: none;
  border-bottom: none;
}
`;

const ArticleImage = styled.img`
  width: 100%;
  display: block;
  object-fit: cover;
  height: 250px;
  aspect-ratio: 180 / 107;

  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const ArticleTextContainer = styled.div`
  padding: ${PADDING.P16};
  background-color: ${REBRAND_COLOR.WHITE};

  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;

const Article = ({
  isBranded = false,
  thumbnail,
  path,
  title,
}) => {
  return (
    <ArticleCard
      href={path}
      trackEventData={{ label: title }}
    >
      <ArticleImage
        src={`/life-done-better/images/${thumbnail}`}
        alt={title}
        loading="lazy"
      />

      <ArticleTextContainer isBranded={isBranded}>
        <Typography.SH4 semibold>
          {title}
        </Typography.SH4>
      </ArticleTextContainer>
    </ArticleCard>
  );
};

export default Article;
